import { render, staticRenderFns } from "./TicketsListView.vue?vue&type=template&id=1a3b9040&"
import script from "./TicketsListView.vue?vue&type=script&lang=js&"
export * from "./TicketsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3b9040')) {
      api.createRecord('1a3b9040', component.options)
    } else {
      api.reload('1a3b9040', component.options)
    }
    module.hot.accept("./TicketsListView.vue?vue&type=template&id=1a3b9040&", function () {
      api.rerender('1a3b9040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/TicketsListView.vue"
export default component.exports